import React, { useState, useEffect } from 'react';
import { logoTolivBlack } from '../../assets/imgs/images';
import { getVersion } from '../../lib/utils';
import { fetchUserBranchOffices } from '../../lib/data';
import LoginModal from './LoginModal/LoginModal';
import PanelAdminModal from './PanelAdminModal/PanelAdminModal';

import './Home.css';

export default function Home (props) {
  const { branchOffice, onClickStart, printAction, changeBranchOffice } = props;
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const [isAdminModalOpen, setIsAdminModalOpen] = useState(false);
  const [accessToken, setAccessToken] = useState(null);
  const [clickCount, setClickCount] = useState(0);
  const [clickTimer, setClickTimer] = useState(null);

  useEffect(() => {
    // Limpiar el temporizador cuando el componente se desmonta
    return () => {
      if (clickTimer) {
        clearTimeout(clickTimer);
      }
    };
  }, [clickTimer]);

  const onClickVersion = () => {
    const newClickCount = clickCount + 1;
    console.log(`onClickVersion - newClickCount: ${newClickCount}`);

    if (clickTimer) {
      clearTimeout(clickTimer);
      console.log('onClickVersion - Timer cleared');
    }

    if (newClickCount === 10) {
      console.log('onClickVersion - Reached 10 clicks, showing modal and resetting count.');
      setClickCount(0); // Reiniciar contador
      setClickTimer(null); // Limpiar referencia del temporizador
      showLoginModal();
    } else {
      setClickCount(newClickCount);
      const timerId = setTimeout(() => {
        console.log('onClickVersion - Timer expired, resetting click count.');
        setClickCount(0); // Reiniciar contador después de 10 segundos
        setClickTimer(null);
      }, 10000); // 10 segundos
      setClickTimer(timerId);
      console.log(`onClickVersion - Timer set for 10 seconds. Timer ID: ${timerId}`);
    }
  };
  
  const showLoginModal = () => {
    setIsLoginModalOpen(true);
  };
  const handleLoginOk = () => {
    setIsLoginModalOpen(false);
  };
  const handleLoginCancel = () => {
    setIsLoginModalOpen(false);
  };
  const onSuccessLogin = async (data) => {
    const token = data.data.access_token;
    if (!branchOffice || !branchOffice.id) {
      alert('No se pudo verificar la sucursal del totem. Reinicia la aplicación.');
      return;
    }

    try {
      const homeResponse = await fetchUserBranchOffices(token);
      // El backend puede responder con distintas formas. Soportamos:
      //   { data: { branch_offices: [...] } }
      //   { data: [...] }
      //   { branch_offices: [...] }
      const branchOffices =
        homeResponse?.data?.branch_offices ||
        homeResponse?.branch_offices ||
        (Array.isArray(homeResponse?.data) ? homeResponse.data : null) ||
        [];

      const hasAccess = branchOffices.some(bo => Number(bo.id) === Number(branchOffice.id));

      if (!hasAccess) {
        alert(
          `Tu usuario no tiene permisos sobre la sucursal "${branchOffice.name}" (ID ${branchOffice.id}).\n\n` +
          `Solicita al administrador de Toliv que asigne tu cuenta a esta sucursal y vuelve a intentar.`
        );
        return;
      }

      setIsLoginModalOpen(false);
      setAccessToken(token);
      showAdminModal();
    } catch (error) {
      console.error('Error verificando permisos:', error);
      alert(`No se pudo verificar permisos sobre la sucursal: ${error.message}`);
    }
  }

  const showAdminModal = () => {
    setIsAdminModalOpen(true);
  };
  const handleAdminOk = () => {
    setIsAdminModalOpen(false);
  };
  const handleAdminCancel = () => {
    setIsAdminModalOpen(false);
  };

  return (
    <div className="home-page">
      <div className="home-page__logo">
        <img src={logoTolivBlack} alt='Toliv' />
      </div>
      <div className="home-page__greeting">
        <p>{branchOffice ? `Bienvenido a ${branchOffice.name}` : 'Bienvenido'}</p>
        <p>¿Que deseas ordenar?</p>
      </div>
      <button onClick={() => onClickStart()}>Empezar</button>
      <p className='version' onClick={onClickVersion}>Versión {getVersion()}</p>
      <LoginModal
        isModalOpen={isLoginModalOpen}
        handleOk={handleLoginOk}
        onSuccessLogin={onSuccessLogin}
        handleClose={handleLoginCancel} />
      <PanelAdminModal
        accessToken={accessToken}
        branchOffice={branchOffice}
        isModalOpen={isAdminModalOpen}
        handleOk={handleAdminOk}
        handleClose={handleAdminCancel}
        printAction={printAction}
        changeBranchOffice={changeBranchOffice} />
    </div>
  )
}